/*
  WhoAreWeModal.js — plain-language orientation modal, deliberately
  NOT in the About section's monster-narrator voice. Answers "what is
  this site" for a first-time visitor, distinct from AboutSection.js's
  mood piece. Triggered from either MenuIcon.js's dropdown or a
  standalone top-chrome button (both call showWhoAreWeModal()).

  Includes a real clickable link that opens Story I directly in the
  reader (director: "less friction, direct action" - skips the picker
  since the copy already names the specific story).

  Rule 74 pattern: built once, cached, reused via visibility toggle.
*/

import { openStoryInReader } from './StoryPicker.js';
import { stories } from '../data/stories.js';

let cachedModal = null;

function buildModal() {
  const overlay = document.createElement('div');
  overlay.dataset.role = 'who-are-we-modal';
  overlay.className = 'waw-overlay';

  const card = document.createElement('div');
  card.className = 'ep-glass waw-card';

  const edge = document.createElement('span');
  edge.className = 'ep-glass-edge';
  edge.setAttribute('aria-hidden', 'true');

  const closeBtn = document.createElement('button');
  closeBtn.className = 'ep-x waw-close';
  closeBtn.setAttribute('aria-label', 'Close');
  closeBtn.textContent = '\u2715';

  const content = document.createElement('div');
  content.className = 'waw-content';
  content.innerHTML = `
    <h2 class="waw-title">Who Are We</h2>
    <p>Stygian Myth is a dark fantasy author. Every story &mdash; live or in progress &mdash; belongs to one world: Nine Deaths.</p>
    <p><strong>Myth's Shorts</strong> are free to read, always. New stories are added periodically.</p>
    <p><strong>Myth's Novels</strong> are the longer works &mdash; currently <em>Dawn of the Fanatic</em>, with its prologue live. Subscribe to get notified as new chapters release.</p>
    <p>New here? Start with <a href="#" class="waw-story-link" data-role="waw-story-link">A Secret from the Pale Man</a>. Four minutes, and you'll know the house style.</p>
    <p>No spam, no paywall on the shorts, no pressure. Just stories.</p>
  `;

  card.append(edge, closeBtn, content);
  overlay.appendChild(card);
  document.body.appendChild(overlay);

  function hide() {
    overlay.classList.remove('waw-visible');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  }

  function show() {
    overlay.classList.add('waw-visible');
    // Lock scroll entirely while the modal is open - same known
    // jump-bug class as LoadingScreen.js (address-bar collapse/reflow
    // interacting badly with fixed/full-viewport elements, Rule 87).
    // Most reliably avoided by preventing scroll outright.
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
  }

  closeBtn.addEventListener('click', hide);
  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) hide();
  });
  window.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && overlay.classList.contains('waw-visible')) hide();
  });

  const storyLink = content.querySelector('[data-role="waw-story-link"]');
  storyLink.addEventListener('click', (e) => {
    e.preventDefault();
    hide();
    const story = stories.find((s) => s.id === 'crows-tale') || stories[0];
    openStoryInReader(story);
  });

  return { show, hide };
}

export function showWhoAreWeModal() {
  if (!cachedModal) {
    cachedModal = buildModal();
  }
  cachedModal.show();
}
